/** Data curta para painéis de monitoramento (pt-BR). */
export function formatMonitoringDate(dateString: string): string {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('pt-BR');
}
